import { Meteor } from 'meteor/meteor';
import { Mongo } from 'meteor/mongo';
import { SimpleSchema } from 'meteor/aldeed:simple-schema';
import { Reservation } from './reservations.js';
import { Address } from './addresses.js';

export const Passengers = new Mongo.Collection('passengers');

Passengers.allow({
    insert() { return true; },
    update() { return true; },
    remove() { return true; },
});

export const Passenger = new SimpleSchema({
    tempID: {
        type: String,
        label: "ID temporaire",
        optional: true
    },
    firstName: {
        type: String,
        label: "Prenom",
        optional: true
    },
    lastName: {
        type: String,
        label: "Nom",
        optional: true
    },
    age: {
        type: SimpleSchema.Integer,
        label: "Age",
        min: 8
    },
    weight: {
        type: Number,
        label: "Poids"
    },
    phone: {
        type: String,
        label: "Téléphone",
        optional: true
    },
    email: {
        type: String,
        label: "Email",
        optional: true
    },
    info: {
        type: String,
        label: "Information",
        optional: true
    },
    price: {
        type: String,
        label: "Prix individuel",
		optional: true
    },
    mobility: {
        type: Boolean,
        label: "Mobilité réduite ?",
        optional: true
    }
  });

Passengers.attachSchema(Passenger);

Meteor.methods({
	'passengers.remove'(passengerId) {
		Passengers.remove(passengerId);
	},
	'passengers.update'({_id, attributes}) {
		Passengers.update(_id, { "$set": attributes });
	},
	'passengers.insert'(attributes) {
		Passengers.insert(attributes);
	}
});

// Helpers :
Passengers.helpers({
    getAEM() {
        if(this.mobility)
            return 'M';

        if(this.age <= 12)
            return 'E';
        else
            return 'A';
    },
    sendSMS(message) {

        let phone = this.phone.slice(1);;
        phone = phone.replace(' ', '');
        phone = phone.replace('.', '');
        phone = '33' + phone;

        console.log('phone', phone);

        if(phone[2] == '6' || phone[2] == '7') {
            Meteor.call('send.sms', {
              'to': phone,
              'message': message,
            });
        }
    }
});



/** WEBPACK FOOTER **
 ** ./src/universal/collections/reservations/passengers.js
 **/